import { ErrorPage } from '@/components/system/ErrorPage';

// This page is shown when to non AI2 email users when the variant is not publicly launched
export const RestrictedPage = () => {
  return (
    <ErrorPage
      error="Unauthorized"
      errorDescription="You are not authorized to access this site. Did you used the correct email account?"
    />
  );
};
